<template>
	<div class="attention page-container">
		<custom-table :pageConfig="pageConfig" :multipleSelection="multipleSelection" :buttonGroup="buttonGroup"
			:filterValue="filterValue" :tableFilter="tableFilter" :tableConfig="tableConfig" :tableData="tableData"
			@pageChange="pageChange" @buttonClick="buttonClick" @filterChange="filterChange"
			@scopeButtonClick="scopeButtonClick">
		</custom-table>
		<el-dialog title="关注用户列表" :visible="dialogVisible" @close="dialogVisible = false">
			<el-table :data="recordData" style="width: 100%" :border="true" :header-cell-style="{background:'#eaf0fa'}">
				<el-table-column label="用户" prop="username" width="400" align="center">
				</el-table-column>
				<el-table-column label="时间" prop="createAt" align="center">
				</el-table-column>
			</el-table>
			<div class="dialog-pager">
				<el-pagination background layout="total, prev, pager, next" :total="recordConfig.total"
					:pager-count="11" :page-size="recordConfig.pageSize" :current-page="recordConfig.currentPage"
					@current-change="recordPageChange">
				</el-pagination>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'attention',
		data() {
			return {
				pageConfig: {
					totalWord: '全部数据',
					total: 0,
					pageSize: 13,
					currentPage: 1,
				},
				multipleSelection: [],
				buttonGroup: [],
				filterValue: {},
				tableFilter: [],
				tableConfig: {
					border: true,
					selection: false,
					showOverflowTooltip: true,
					tableHeader: [{
							prop: 'lotName',
							label: '商品名称',
							width: 300
						},
						{
							prop: 'lotAuthor',
							label: '作者',
							width: 100
						},
						{
							prop: 'lotPictrueSize',
							label: '文件大小（KB）',
							width: 130
						},
						{
							prop: 'createAt',
							label: '开始时间',
							width: 250
						},
						{
							prop: 'endTime',
							label: '结束时间',
							width: 250
						},
						{
							prop: 'lotStatus',
							label: '当前状态',
							width: 100,
							template: true
						},
						{
							prop: 'lotLabel',
							label: '标签',
							width: 300
						}
					],
					tableEvent: [{
						icon: 'el-icon-user',
						name: '关注用户列表',
						color: 'blue',
						sign: 'record'
					}],
					emptyDescription: '当前没有数据',
				},
				tableData: [],
				dialogVisible: false,
				recordConfig: {
					total: 0,
					pageSize: 8,
					currentPage: 1
				},
				recordData: []
			};
		},
		methods: {
			// 页面变化
			pageChange() {

			},
			// 右上按钮
			buttonClick(sign) {
				if (sign === 'new') {
					this.$router.push({
						path: '/itemedit'
					})
				}
			},
			// 筛选条件变化
			filterChange() {
				console.log(this.filterValue);
			},
			// 操作按钮
			scopeButtonClick(row, sign) {
				if (sign === 'record') {
					this.$api.attentionUserList({
						pageSize:this.recordConfig.pageSize,
						pageNum:this.recordConfig.currentPage,
						lotId: row.id
					},res=>{
						if(res.code==200){
							this.recordData = res.data.list
							this.recordConfig.total = res.data.total
							this.dialogVisible = true
						}
					})
				}
			},
			recordPageChange(e) {
				this.recordConfig.currentPage = e
			},
			fetchData() {
				this.$api.attentionCommodity({
					pageSize: this.pageConfig.pageSize,
					pageNum: this.pageConfig.currentPage
				}, res => {
					if (res.code == 200) {
						this.tableData = res.data.list
						this.pageConfig.total = res.data.total
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.dialog-pager {
		width: 100%;
		height: 70px;
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}
</style>
